import type { ListingStatus } from "@/data/types";

export function formatPriceShort(value?: number): string | null {
  if (value == null || Number.isNaN(value)) return null;
  if (value >= 1_000_000) {
    const m = value / 1_000_000;
    const trimmed = m.toFixed(3).replace(/\.?0+$/, "");
    return `$${trimmed}M`;
  }
  if (value >= 1000) {
    return `$${Math.round(value / 1000)}K`;
  }
  return `$${value.toLocaleString("en-US")}`;
}

export function formatPriceFull(value?: number): string | null {
  if (value == null || Number.isNaN(value)) return null;
  return `$${value.toLocaleString("en-US")}`;
}

const STATUS_LABELS: Record<ListingStatus, string> = {
  expired: "Expired",
  withdrawn: "Withdrawn",
  off_market: "Off market",
  active: "Active",
  sold: "Sold",
};

export function formatStatus(status?: ListingStatus): string | null {
  if (!status) return null;
  return STATUS_LABELS[status] ?? null;
}

export function formatBaths(value?: number): string | null {
  if (value == null) return null;
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

// Builds the full address line, gracefully skipping missing parts.
export function fullAddressLine(parts: {
  address: string;
  unit?: string;
  neighborhood?: string;
  city?: string;
}): string {
  const primary = parts.unit ? `${parts.address}, ${parts.unit}` : parts.address;
  return primary;
}

export function locationLine(parts: {
  neighborhood?: string;
  city?: string;
}): string | null {
  const bits = [parts.neighborhood, parts.city].filter(Boolean);
  return bits.length ? bits.join(", ") : null;
}
